import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../Base';
import UserCard from "../UserCard";
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class Supports extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'support',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 30,
            phrase: ''
        };
    }
    componentDidMount() {
        this.refreshData();
    }
    getStatusText(status) {
        if (status === 1) return <span className="badge rounded-pill bg-primary">در انتظار پاسخ</span>;
        if (status === 2) return <span className="badge rounded-pill bg-success">پاسخ داده شده</span>;
        if (status === 3) return <span className="badge rounded-pill bg-warning">ارجاع شده</span>;
        if (status === 4) return <span className="badge rounded-pill bg-danger">بسته شده</span>;
        return '';
    }
    onShowUserCard(id) {
        this.showComponents({ component: <UserCard Caller={this} Id={id} /> });
    }
    renderForm() {
        return <div>
                    <div className="nk-content-body">
                        <div className="nk-block-head nk-block-head-sm">
                            <div className="nk-block-between">
                                <div className="nk-block-head-content">
                                    <h3 className="nk-block-title page-title">فهرست پیامهای پشتیبانی</h3>
                                    <div className="nk-block-des text-soft">
                                <p>شما {this.money(this.state.data.recordsCount) } پیام ثبت شده دارید</p>
                                    </div>
                                </div>
                                <div className="nk-block-head-content">
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                        <div className="toggle-expand-content" data-content="pageMenu">
                                            <ul className="nk-block-tools g-3">
                                                <li>
                                            <NavLink to="/support/new/" className="btn btn-primary"><em className="icon ni ni-plus"></em><span>ارسال پیام جدید</span></NavLink>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="nk-block">
                            <div className="card card-bordered card-stretch">
                        {this.state.data.recordsCount <= 0 ?
                                    <div className="card-inner-group">
                                        <div className="example-alert">
                                            <div className="alert alert-pro alert-warning">
                                                <div className="alert-text">
                                                    <h6>توجه</h6>
                                                    <p>در حال حاضر هیچ پیامی ثبت نشده است</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                :
                                    <div className="card-inner-group">
                                        <div className="card-inner position-relative card-tools-toggle">
                                            <div className="card-title-group">
                                                <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                                    <div className="form-inline flex-nowrap gx-3">
                                                        <div className="form-wrap">
                                                            <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="موضوع پیام" className="form-control" />
                                                        </div>
                                                        <div className="btn-wrap">
                                                            <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="card-inner p-0">
                                            <div className="nk-tb-list nk-tb-ulist">
                                                <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">موضوع</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">کاربر</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره تماس</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">آدرس ایمیل</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">آخرین تغییر</span></div>
                                                    <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                                </div>
                                        {this.state.data.records.map((record,index) =>
                                                    <div className="nk-tb-item">
                                                        <div className="nk-tb-col">
                                                            <span className="sub-text">{this.genRowNumber(index)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.number}</span>
                                                </div>   
                                                        <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.topicString}</span>
                                                </div>           
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.userId !== null && <a className="hand" onClick={e => this.onShowUserCard(record.userId)} title="مشاهده کارت عملکرد کاربر"><em className="icon ni ni-info"></em></a>} {record.userName}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.userMobile}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.userEmail}</span>
                                                </div>                
                                                
                                                        <div className="nk-tb-col">
                                                            <span className="sub-text text-center">{this.getStatusText(record.status)}</span>
                                                        </div>                                                 
                                                        <div className="nk-tb-col">
                                                            <span className="sub-text text-center">{record.date}</span>
                                                        </div>                                       
                                                        <div className="nk-tb-col nk-tb-col-tools">
                                                            <ul className="nk-tb-actions gx-1">
                                                                <li className="nk-tb-action-hidden">
                                                            <NavLink to={"/support/edit/" + record.id + "/"} className="btn btn-trigger btn-icon" title="مشاهده و ویرایش">
                                                                        <em className="icon ni ni-eye-fill"></em>
                                                                    </NavLink>
                                                                </li>
                                                                <li>
                                                                    <div className="drodown">
                                                                        <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                        <div className="dropdown-menu dropdown-menu-end">
                                                                            <ul className="link-list-opt no-bdr">
                                                                        <li><NavLink to={"/support/edit/" + record.id + "/"}><em className="icon ni ni-eye"></em><span>مشاهده و ویرایش</span></NavLink></li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        { this.createPaging() }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>


                </div>
        
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : 
                    [
                        this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                        <div className="nk-content ">
                            <div className="container-fluid">
                                <div className="nk-content-inner">
                                    {this.renderForm()}
                                </div>
                            </div>
                        </div>,
                        <Footer />
                    ];

        return contents;
    }
}